
  
  <span class="shape-1"></span>
  <span class="shape-2"></span>
  <span class="shape-3"></span>
  <section class="banner-section" *ngIf="!seeArticle">
    <div class="container">
      <div class="row justify-content-center">
        <!-- <div class="col-12">
          <div class="filterBy">
            <span>Filter by Publishers:</span>
            <ul class="journal-tabs">
              <li>
                <a href="/journal-finder" class="active">All</a>
              </li>
              <li>
                <a href="/journal-finder/elsevier">Elsevier</a>
              </li>
              <li>
                <a href="/journal-finder/springer-nature">Nature Springer</a>
              </li>
              <li>
                <a href="/journal-finder/wiley">Wiley</a>
              </li>
              <li>
                <a href="/journal-finder/taylor-and-francis">Taylor & Francis </a>
              </li>
              <li>
                <a href="/journal-finder/sage">Sage</a>
              </li>
            </ul>
          </div>
        </div> -->
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h2>免費期刊查找工具 </h2>
            </div>
            <div class="card-body">
              <div class="form-group mb-0">
                <textarea
                  class="form-control"
                  [ngClass]="[
                    isProcessingStarted ? 'searchingResultJournalFinder' : ''
                  ]"
                  placeholder="請在此處貼上您的摘要（至少50字）"
                  [(ngModel)]="searchText" contenteditable="true"
                  (input)="onInputEditorChange($event.target.innerText)" id="journalFinderTextarea"
                ></textarea>
              </div>
              <div class="error-message" *ngIf="isWordLimit">
                <svg
                  width="18"
                  height="17"
                  viewBox="0 0 18 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.5008 13.6946L10.6688 1.82974C10.4981 1.53906 10.2544 1.29803 9.96178 1.13057C9.66921 0.9631 9.33795 0.875 9.00084 0.875C8.66373 0.875 8.33247 0.9631 8.0399 1.13057C7.74732 1.29803 7.50359 1.53906 7.33287 1.82974L0.500838 13.6946C0.336569 13.9757 0.25 14.2955 0.25 14.6211C0.25 14.9468 0.336569 15.2665 0.500838 15.5477C0.669377 15.8401 0.91269 16.0825 1.20581 16.2498C1.49893 16.4172 1.83129 16.5036 2.16881 16.5001H15.8329C16.1701 16.5033 16.5022 16.4168 16.795 16.2494C17.0878 16.0821 17.3309 15.8399 17.4993 15.5477C17.6638 15.2667 17.7506 14.947 17.7509 14.6214C17.7512 14.2957 17.6649 13.9759 17.5008 13.6946ZM8.37584 7.12505C8.37584 6.95929 8.44169 6.80032 8.5589 6.68311C8.67611 6.5659 8.83508 6.50005 9.00084 6.50005C9.1666 6.50005 9.32557 6.5659 9.44278 6.68311C9.55999 6.80032 9.62584 6.95929 9.62584 7.12505V10.2501C9.62584 10.4158 9.55999 10.5748 9.44278 10.692C9.32557 10.8092 9.1666 10.8751 9.00084 10.8751C8.83508 10.8751 8.67611 10.8092 8.5589 10.692C8.44169 10.5748 8.37584 10.4158 8.37584 10.2501V7.12505ZM9.00084 14.0001C8.81542 14.0001 8.63416 13.9451 8.47999 13.8421C8.32582 13.739 8.20566 13.5926 8.1347 13.4213C8.06374 13.25 8.04518 13.0615 8.08135 12.8797C8.11753 12.6978 8.20681 12.5308 8.33792 12.3996C8.46904 12.2685 8.63608 12.1792 8.81794 12.1431C8.9998 12.1069 9.1883 12.1255 9.3596 12.1964C9.53091 12.2674 9.67733 12.3875 9.78034 12.5417C9.88335 12.6959 9.93834 12.8771 9.93834 13.0626C9.93834 13.3112 9.83957 13.5496 9.66375 13.7255C9.48794 13.9013 9.24948 14.0001 9.00084 14.0001Z"
                    fill="#FB923C"
                  />
                </svg>
                <p>Please write minimum 50 words</p>
                <button
                  type="button"
                  aria-label="Close error message"
                  (click)="isWordLimit = !isWordLimit"
                >
                  <img
                    src="../../../assets/images/close-circle.svg"
                    alt="close"
                  />
                </button>
              </div>
            </div>
            <div class="card-footer">
              <!-- <div class="note">
                <small>Minimum 5 Sentences (50+ words)</small>
              </div> -->
              <div class="btn-group">
                <button
                  type="submit"
                  class="filled-btn"
                  (click)="searchJournalSubmit()"
                  [disabled]="isProcessingStarted || disableButton"
                  *ngIf="journalFinalResult.journal_data.length == 0"
                >
                  <span
                    *ngIf="isProcessingStarted"
                    class="animated-loader"
                  ></span>
                  {{
                    isProcessingStarted ? "Finding Journals..." : "搜尋期刊"
                  }}
                </button>
                <button
                  class="journalFinderCancleButton"
                  type="cancel"
                  (click)="clearResult()"
                  *ngIf="journalFinalResult.journal_data.length > 0"
                >
                  Clear
                </button>
                <!-- <button type="button" class="outline-btn">Cancel</button> -->
              </div>
              <div class="note"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section
    id="resultSection"
    class="resultSection section-pd-sm"
    [class.sticky]="isSticky"
    *ngIf="!seeArticle"
  >
    <div class="filterSection" *ngIf="journalFinalResult.journal_data.length > 0">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h6>Filters</h6>
            <div class="filter-section">
              <div class="row justify-content-center">
                <div class="col-lg-12 col-xl-12">
                  <ul>
                    <li class="popover-item">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.25 5.9375H14.0625V4.375C14.0625 3.29756 13.6345 2.26425 12.8726 1.50238C12.1108 0.740512 11.0774 0.3125 10 0.3125C8.92256 0.3125 7.88925 0.740512 7.12738 1.50238C6.36551 2.26425 5.9375 3.29756 5.9375 4.375V5.9375H3.75C3.3356 5.9375 2.93817 6.10212 2.64515 6.39515C2.35212 6.68817 2.1875 7.0856 2.1875 7.5V16.25C2.1875 16.6644 2.35212 17.0618 2.64515 17.3549C2.93817 17.6479 3.3356 17.8125 3.75 17.8125H16.25C16.6644 17.8125 17.0618 17.6479 17.3549 17.3549C17.6479 17.0618 17.8125 16.6644 17.8125 16.25V7.5C17.8125 7.0856 17.6479 6.68817 17.3549 6.39515C17.0618 6.10212 16.6644 5.9375 16.25 5.9375ZM7.8125 4.375C7.8125 3.79484 8.04297 3.23844 8.4532 2.8282C8.86344 2.41797 9.41984 2.1875 10 2.1875C10.5802 2.1875 11.1366 2.41797 11.5468 2.8282C11.957 3.23844 12.1875 3.79484 12.1875 4.375V5.9375H7.8125V4.375ZM15.9375 15.9375H4.0625V7.8125H15.9375V15.9375ZM10 8.75C9.41999 8.75021 8.85811 8.95209 8.41059 9.32105C7.96307 9.69001 7.65776 10.2031 7.54696 10.7724C7.43617 11.3417 7.52677 11.9319 7.80326 12.4417C8.07974 12.9516 8.52491 13.3495 9.0625 13.5672V14.0625C9.0625 14.3111 9.16127 14.5496 9.33709 14.7254C9.5129 14.9012 9.75136 15 10 15C10.2486 15 10.4871 14.9012 10.6629 14.7254C10.8387 14.5496 10.9375 14.3111 10.9375 14.0625V13.5672C11.4751 13.3495 11.9203 12.9516 12.1967 12.4417C12.4732 11.9319 12.5638 11.3417 12.453 10.7724C12.3422 10.2031 12.0369 9.69001 11.5894 9.32105C11.1419 8.95209 10.58 8.75021 10 8.75ZM10 10.625C10.1236 10.625 10.2445 10.6617 10.3472 10.7303C10.45 10.799 10.5301 10.8966 10.5774 11.0108C10.6247 11.125 10.6371 11.2507 10.613 11.3719C10.5889 11.4932 10.5294 11.6045 10.4419 11.6919C10.3545 11.7794 10.2432 11.8389 10.1219 11.863C10.0007 11.8871 9.87503 11.8747 9.76082 11.8274C9.64662 11.7801 9.54901 11.7 9.48033 11.5972C9.41166 11.4945 9.375 11.3736 9.375 11.25C9.375 11.0842 9.44085 10.9253 9.55806 10.8081C9.67527 10.6908 9.83424 10.625 10 10.625Z"
                          fill="#414E62"
                        />
                      </svg>
                      Target Journal
                      <span
                        ><i class="fa fa-caret-down" aria-hidden="true"></i
                      ></span>
                      <div class="popover-content">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Search"
                          />
                          <small
                            >To access this feature
                            <a
                              href="https://cloud.trinka.ai/signup?_rg=GB"
                              target="_blank" rel="noopener noreferrer"
                              >Sign up</a
                            >
                            to Trinka AI</small
                          >
                        </div>
                        <div
                          class="form-check"
                          *ngFor="let name of journalFinalResult.journal_list"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="check1"
                            name="option1"
                            value="something"
                            disabled
                          />
                          <label class="form-check-label" for="check1">{{
                            name
                          }}</label>
                        </div>
                        <!-- <div class="form-check">
                                                                                                  <input type="checkbox" class="form-check-input" id="check2" name="option2" value="something" disabled>
                                                                                                  <label class="form-check-label" for="check2">Applied Mechanics and Materials</label>
                                                                                          </div>
                                                                                          <div class="form-check">
                                                                                                  <input type="checkbox" class="form-check-input" disabled>
                                                                                                  <label class="form-check-label">Sensors</label>
                                                                                          </div> -->
                      </div>
                    </li>
                    <li class="popover-item">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.25 5.9375H14.0625V4.375C14.0625 3.29756 13.6345 2.26425 12.8726 1.50238C12.1108 0.740512 11.0774 0.3125 10 0.3125C8.92256 0.3125 7.88925 0.740512 7.12738 1.50238C6.36551 2.26425 5.9375 3.29756 5.9375 4.375V5.9375H3.75C3.3356 5.9375 2.93817 6.10212 2.64515 6.39515C2.35212 6.68817 2.1875 7.0856 2.1875 7.5V16.25C2.1875 16.6644 2.35212 17.0618 2.64515 17.3549C2.93817 17.6479 3.3356 17.8125 3.75 17.8125H16.25C16.6644 17.8125 17.0618 17.6479 17.3549 17.3549C17.6479 17.0618 17.8125 16.6644 17.8125 16.25V7.5C17.8125 7.0856 17.6479 6.68817 17.3549 6.39515C17.0618 6.10212 16.6644 5.9375 16.25 5.9375ZM7.8125 4.375C7.8125 3.79484 8.04297 3.23844 8.4532 2.8282C8.86344 2.41797 9.41984 2.1875 10 2.1875C10.5802 2.1875 11.1366 2.41797 11.5468 2.8282C11.957 3.23844 12.1875 3.79484 12.1875 4.375V5.9375H7.8125V4.375ZM15.9375 15.9375H4.0625V7.8125H15.9375V15.9375ZM10 8.75C9.41999 8.75021 8.85811 8.95209 8.41059 9.32105C7.96307 9.69001 7.65776 10.2031 7.54696 10.7724C7.43617 11.3417 7.52677 11.9319 7.80326 12.4417C8.07974 12.9516 8.52491 13.3495 9.0625 13.5672V14.0625C9.0625 14.3111 9.16127 14.5496 9.33709 14.7254C9.5129 14.9012 9.75136 15 10 15C10.2486 15 10.4871 14.9012 10.6629 14.7254C10.8387 14.5496 10.9375 14.3111 10.9375 14.0625V13.5672C11.4751 13.3495 11.9203 12.9516 12.1967 12.4417C12.4732 11.9319 12.5638 11.3417 12.453 10.7724C12.3422 10.2031 12.0369 9.69001 11.5894 9.32105C11.1419 8.95209 10.58 8.75021 10 8.75ZM10 10.625C10.1236 10.625 10.2445 10.6617 10.3472 10.7303C10.45 10.799 10.5301 10.8966 10.5774 11.0108C10.6247 11.125 10.6371 11.2507 10.613 11.3719C10.5889 11.4932 10.5294 11.6045 10.4419 11.6919C10.3545 11.7794 10.2432 11.8389 10.1219 11.863C10.0007 11.8871 9.87503 11.8747 9.76082 11.8274C9.64662 11.7801 9.54901 11.7 9.48033 11.5972C9.41166 11.4945 9.375 11.3736 9.375 11.25C9.375 11.0842 9.44085 10.9253 9.55806 10.8081C9.67527 10.6908 9.83424 10.625 10 10.625Z"
                          fill="#414E62"
                        />
                      </svg>
                      Geography
                      <span
                        ><i class="fa fa-caret-down" aria-hidden="true"></i
                      ></span>
                      <div class="popover-content">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Search"
                          />
                          <small
                            >To access this feature
                            <a
                              href="https://cloud.trinka.ai/signup?_rg=GB"
                              target="_blank" rel="noopener noreferrer"
                              >Sign up</a
                            >
                            to Trinka AI</small
                          >
                        </div>
                        <div
                          class="form-check"
                          *ngFor="
                            let regions of journalFinalResult.filter_support_data
                              .regions
                          "
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="check1"
                            name="option1"
                            value="something"
                            disabled
                          />
                          <label class="form-check-label" for="check1">{{
                            regions
                          }}</label>
                        </div>
                        <!-- <div class="form-check">
                                                                                                  <input type="checkbox" class="form-check-input" id="check2" name="option2" value="something" disabled>
                                                                                                  <label class="form-check-label" for="check2">United States</label>
                                                                                          </div>
                                                                                          <div class="form-check">
                                                                                                  <input type="checkbox" class="form-check-input" disabled>
                                                                                                  <label class="form-check-label">Japan</label>
                                                                                          </div>
                                                                                          <div class="form-check">
                                                                                                  <input type="checkbox" class="form-check-input" disabled>
                                                                                                  <label class="form-check-label">PL</label>
                                                                                          </div>
                                                                                          <div class="form-check">
                                                                                                  <input type="checkbox" class="form-check-input" disabled>
                                                                                                  <label class="form-check-label">China</label>
                                                                                          </div>
                                                                                          <div class="form-check">
                                                                                                  <input type="checkbox" class="form-check-input" disabled>
                                                                                                  <label class="form-check-label">South Korea</label>
                                                                                          </div> -->
                      </div>
                    </li>
                    <li class="popover-item">
                      Impact Factor
                      <span
                        ><i class="fa fa-caret-down" aria-hidden="true"></i
                      ></span>
                      <div class="popover-content">
                        <div class="note">
                          Impact factor is a measure of the frequency with which
                          the “average article” in a journal has been cited in a
                          particular year or period.
                        </div>
                        <h6>Select range to filter</h6>
                        <div class="range-box">
                          <label>Min</label>
                          <input
                            type="number"
                            class="form-control"
                            placeholder="0"
                            oninput="value>=0 ||(value='');"
                            [(ngModel)]="impact_factor_custom.min"
                            (click)="$event.stopPropagation()"
                          />
                          <label>-</label>
                          <input
                            type="number"
                            class="form-control"
                            placeholder="0"
                            oninput="value>=0 ||(value='');"
                            [(ngModel)]="impact_factor_custom.max"
                            (click)="$event.stopPropagation()"
                          />
                          <label>Max</label>
                        </div>
                        <div class="error" [ngClass]="isNumber(impact_factor_custom.max) =='number' && isNumber(impact_factor_custom.min) =='number'? impact_factor_custom.min> impact_factor_custom.max ? '' : 'shine_loader_hide' : 'shine_loader_hide' "><span>Min value cannot be greater than Max value</span></div>
                        <div class="popoverResetButton">
                          <button (click)="resetFilter('impact')">Reset</button>
                        </div>
                      </div>
                    </li>
                    <li class="popover-item">
                      H Index
                      <span
                        ><i class="fa fa-caret-down" aria-hidden="true"></i
                      ></span>
                      <div class="popover-content">
                        <div class="note">
                          The H index or Hirsch index is the journal’s number of
                          articles (h) that have received at least h citations. It
                          qualifies both journal scientific productivity and
                          scientific impact.
                        </div>
                        <h6>Select range to filter</h6>
                        <div class="range-box">
                          <label>Min</label>
                          <input
                            type="number"
                            class="form-control"
                            placeholder="0"
                            oninput="value>=0 ||(value='');"
                            [(ngModel)]="hIndex_custom.min"
                            (click)="$event.stopPropagation()"
                          />
                          <label>-</label>
                          <input
                            type="number"
                            class="form-control"
                            placeholder="0"
                            oninput="value>=0 ||(value='');"
                            [(ngModel)]="hIndex_custom.max"
                            (click)="$event.stopPropagation()"
                          />
                          <label>Max</label>
                        </div>
                        <div class="error" [ngClass]="isNumber(hIndex_custom.max) =='number' && isNumber(hIndex_custom.min) =='number'? hIndex_custom.min> hIndex_custom.max ? '' : 'shine_loader_hide' : 'shine_loader_hide' "><span>Min value cannot be greater than Max value</span></div>
                        <div class="popoverResetButton">
                          <button (click)="resetFilter('hindex')">Reset</button>
                        </div>
                      </div>
                    </li>
                    <li class="popover-item">
                      Cite Score
                      <span
                        ><i class="fa fa-caret-down" aria-hidden="true"></i
                      ></span>
                      <div class="popover-content mob-right">
                        <div class="note">
                          CiteScore metric is the measure of the number of
                          citations received in a year against the number of
                          articles published by the journal in the previous 3
                          years.
                        </div>
                        <h6>Select range to filter</h6>
                        <div class="range-box">
                          <label>Min</label>
                          <input
                            type="number"
                            class="form-control"
                            placeholder="0"
                            oninput="value>=0 ||(value='');"
                            [(ngModel)]="citeScore_custom.min"
                            (click)="$event.stopPropagation()"
                          />
                          <label>-</label>
                          <input
                            type="number"
                            class="form-control"
                            placeholder="0"
                            oninput="value>=0 ||(value='');"
                            [(ngModel)]="citeScore_custom.max"
                            (click)="$event.stopPropagation()"
                          />
                          <label>Max</label>
                        </div>
                        <div class="error" [ngClass]="isNumber(citeScore_custom.max) =='number' && isNumber(citeScore_custom.min) =='number'? citeScore_custom.min> citeScore_custom.max ? '' : 'shine_loader_hide' : 'shine_loader_hide' "><span>Min value cannot be greater than Max value</span></div>
                        <div class="popoverResetButton">
                          <button (click)="resetFilter('cite')">Reset</button>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="form-check form-switch">
                        <div class="switch-box">
                          <label class="switch">
                            <input
                              type="checkbox"
                              [checked]="filterList.show_open_access"
                              (change)="
                                changeCheckboxFilter(
                                  'show_open_access',
                                  'Show open access only'
                                )
                              "
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        <label class="form-check-label" for="openAccess"
                          >Show open access only</label
                        >
                      </div>
                    </li>
                    <li>
                      <div class="form-check form-switch">
                        <div class="switch-box">
                          <label class="switch">
                            <input
                              type="checkbox"
                              [checked]="filterList.hide_predatory_journals"
                              (change)="
                                changeCheckboxFilter(
                                  'hide_predatory_journals',
                                  'Hide predatory journals'
                                )
                              "
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                        <label class="form-check-label" for="predatoryJournal"
                          >Hide predatory journal</label
                        >
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ul class="filterResults">
              <li
                *ngIf="
                  impact_factor_custom.min != 0 || impact_factor_custom.max != 0
                "
              >
                <b>Impact Factor:</b> {{ impact_factor_custom.min }} -
                {{ impact_factor_custom.max }}
                <button type="button" (click)="resetFilter('impact')">
                  <img src="../../../assets/icons/close-red.svg" alt="icon" />
                </button>
              </li>
              <li *ngIf="hIndex_custom.min != 0 || hIndex_custom.max != 0">
                <b>H - Index:</b> {{ hIndex_custom.min }} -
                {{ hIndex_custom.max }}
                <button type="button" (click)="resetFilter('hindex')">
                  <img src="../../../assets/icons/close-red.svg" alt="icon" />
                </button>
              </li>
              <li *ngIf="citeScore_custom.min != 0 || citeScore_custom.max != 0">
                <b>Cite Score:</b> {{ citeScore_custom.min }} -
                {{ citeScore_custom.max }}
                <button type="button" (click)="resetFilter('cite')">
                  <img src="../../../assets/icons/close-red.svg" alt="icon" />
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="container" *ngIf="journalFinalResult.journal_data.length > 0">
      <div class="row">
        <div class="col-12">
          <h6 style="font-size: 24px;">Results</h6>
          <p style="font-size: 16px">
            We have sampled {{ journalFinalResult.sample_count || 0 }} articles
            from {{ journalFinalResult.journal_data.length || 0 }} journals to give
            this recommendation.
          </p>
        </div>
        <div class="col-12">
          <div class="closeAll">
            <a
              href=""
              class="text-link"
              (click)="toggleAccordion($event)"
              [ngClass]="{ collapsed: isCollapsed }"
            >
              {{ isCollapsed ? "Expand All" : "Close All" }}
              <span>
                <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.46978 5.47173C9.20943 5.73208 8.78732 5.73208 8.52697 5.47173L4.99837 1.94314L1.46978 5.47173C1.20943 5.73208 0.787319 5.73208 0.52697 5.47173C0.26662 5.21138 0.26662 4.78927 0.52697 4.52892L4.52697 0.528922C4.78732 0.268573 5.20943 0.268573 5.46978 0.528922L9.46978 4.52892C9.73013 4.78927 9.73013 5.21138 9.46978 5.47173Z"
                    fill="#1A64E2"
                  />
                </svg>
              </span>
            </a>
          </div>
        </div>
        <div class="col-12">
          <ng-container
            *ngFor="
              let item of journalFinalResult.journal_data
                | citeScoreFilter : citeScore_custom.min : citeScore_custom.max
                | openAccessFilter : filterDisplayList
                | predatoryFilter : filterDisplayList
                | impactFactorFilter
                  : impact_factor_custom.min
                  : impact_factor_custom.max
                | HIndexFilter : hIndex_custom.min : hIndex_custom.max;
              let i = index
            "
          >
            <div *ngIf="i < 3" class="journal-card" id="accordion{{ i + 1 }}">
              <span class="rank">Rank #{{ item.journal_rank }}</span>
              <div class="row">
                <div class="col-12">
                  <div class="media">
                    <div class="media-left">
                      <img
                        src="../../../assets/icons/OpenAccess.svg"
                        alt="icon"
                      />
                    </div>
                    <div class="media-body">
                      <h3>{{ item.journal_title }}</h3>
                      <p style="display: flex">
                        Publisher:
                        <span
                          style="
                            display: flex;
                            align-items: center;
                            padding-left: 5px;
                          "
                        >
                          <b style="margin-right: 8px;"
                            title="{{ item.publisher }}"
                            >{{ item.publisher }}</b
                          >
                          |
                          <a
                            [href]="item.website_url"
                            class="text-link"
                            style="margin-left: 5px"
                            target="_blank" rel="noopener noreferrer"
                            >Journal Website</a
                          >
                        </span>
                      </p>
                    </div>
                    <a
                      data-toggle="collapse"
                      href="#collapseOne{{ i + 1 }}"
                      class="cd-collapse"
                    >
                      <svg
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.7052 7.70711C13.3146 8.09763 12.6815 8.09763 12.2909 7.70711L6.99805 2.41421L1.70515 7.70711C1.31463 8.09763 0.681463 8.09763 0.290939 7.70711C-0.099586 7.31658 -0.099586 6.68342 0.290939 6.29289L6.29094 0.292893C6.68146 -0.0976314 7.31463 -0.0976314 7.70515 0.292893L13.7052 6.29289C14.0957 6.68342 14.0957 7.31658 13.7052 7.70711Z"
                          fill="#1A64E2"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div class="col-12">
                  <div
                    id="collapseOne{{ i + 1 }}"
                    class="collapse show"
                    data-parent="#accordion{{ i + 1 }}"
                  >
                    <div class="row">
                      <div class="col-lg-5">
                        <div class="journal-left-content">
                          <ul class="badge-listing">
                            <li class="impactFactorTooltip">Impact Factor: {{ item.impact_factor }}
                              <div>
                                <p>Impact factor is a measure of the frequency with which the "average article" in a journal has been cited in a particular year or period.</p>
                                <em>Source: <a href="#">Clarivate</a></em>
                              </div>
                            </li>
                            <li class="hIndexTooltip">H Index: {{ item.h_index }}
                              <div>
                                <p>The H index or Hirsch index is the journal's number of articles (h) that have received at least h citations. It quantifies both journal scientific productivity and scientific impact. <br /><br />
                                  Publishing in a high H-index journal maximizes your chances of being cited by other authors and, consequently, may improve your own personal H index score. </p>
                              </div>
                            </li>
                            <li class="citeScoreTooltip">Cite score: {{ item.cite_score }}
                              <div>
                                <p>CiteScore metric is the measure of the number of citations received in a year against the number of articles published by the journal in the previous 3 years. <br /><br />
                                  Eg. To calculate value for 2019, CiteScore considers citations received for all articles in 2019 to total number or articles published in 2018, 2017 and 2016. </p>
                              </div>
                            </li>
                          </ul>
                          <div class="lang-content">
                            <p>
                              Language: <b>{{ item.language }}</b>
                            </p>
                            <p>
                              Geography: <b>{{ item.geography }}</b>
                            </p>
                          </div>
                          <div class="button-link">
                            <button
                              type="button"
                              (click)="seePublishArticle(item)"
                            >
                              See all similar articles published ({{ item.similar_article_count }})
                              <!-- <svg
                                width="6"
                                height="10"
                                viewBox="0 0 6 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M0.527293 9.47075C0.266944 9.2104 0.266944 8.78829 0.527293 8.52794L4.05589 4.99935L0.527293 1.47075C0.266944 1.2104 0.266944 0.788295 0.527293 0.527946C0.787643 0.267595 1.20975 0.267595 1.4701 0.527946L5.4701 4.52795C5.73045 4.78829 5.73045 5.2104 5.4701 5.47075L1.4701 9.47075C1.20975 9.7311 0.787643 9.7311 0.527293 9.47075Z"
                                  fill="#1A64E2"
                                />
                              </svg> -->
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-7">
                        <div class="graph">
                          <ul>
                            <li>
                              <div
                                (click)="changeChartType('bar')"
                                class="cursorPointer"
                                [ngClass]="
                                  chartType == 'bar' ? 'active' : ''
                                "
                              >
                                <svg
                                  width="30"
                                  height="24"
                                  viewBox="0 0 30 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    x="1.39844"
                                    y="0.5"
                                    width="28.0245"
                                    height="23"
                                    rx="3.5"
                                    stroke="black"
                                  />
                                  <rect
                                    x="7.90625"
                                    y="8"
                                    width="3.00253"
                                    height="12"
                                    rx="0.5"
                                    fill="black"
                                  />
                                  <rect
                                    x="11.9102"
                                    y="13"
                                    width="3.00253"
                                    height="7"
                                    rx="0.5"
                                    fill="black"
                                  />
                                  <rect
                                    x="15.9141"
                                    y="4"
                                    width="3.00253"
                                    height="16"
                                    rx="0.5"
                                    fill="black"
                                  />
                                  <rect
                                    x="19.918"
                                    y="8"
                                    width="3.00253"
                                    height="12"
                                    rx="0.5"
                                    fill="black"
                                  />
                                </svg>
                              </div>
                            </li>
                            <li>
                              <div
                                (click)="changeChartType('line')"
                                class="cursorPointer"
                                [ngClass]="chartType == 'line' ? 'active' : ''"
                              >
                                <svg
                                  width="29"
                                  height="24"
                                  viewBox="0 0 29 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    x="0.5"
                                    y="0.5"
                                    width="28"
                                    height="23"
                                    rx="4.5"
                                    stroke="#000"
                                  />
                                  <path
                                    d="M18.9985 7.95163L13.8525 13.0986H13.1445L11.4985 11.4516L7.85253 15.0986L7.14453 14.3906L11.1445 10.3906H11.8525L13.4985 12.0376L18.6445 6.89062H19.3515L21.3515 8.89062L20.6445 9.59863L18.9985 7.95163Z"
                                    fill="#000"
                                  />
                                  <path
                                    d="M21 17.7461V18.7461H7.5L7 18.2461V4.74609H8V17.7461H21Z"
                                    fill="#000"
                                  />
                                </svg>
                              </div>
                            </li>
                          </ul>
                          <app-chart
                            [id]="'chart' + item.journal_rank"
                            [dataSource]="returnSourceData(item)"
                            [chartType]="chartType"
                          ></app-chart>
  
                          <p>
                            {{calculateYearsOfData(item)}}-year publication trend: <b>{{ item.similar_article_count }}</b> articles with similar concepts published
                            <span>Higher number of articles published in the last {{calculateYearsOfData(item)}} years will increase your chances of acceptance. It shows the interest of the Journal to publish articles in similar subject areas. </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="journal-blur">
            <img
              src="../../../assets/images/journal-finder/journal-finder.png"
              loading="lazy"
              decoding="async"
              alt="journals"
              class="img-fluid"
            />
            <div class="locked-result">
              <h5>Locked Result</h5>
              <p>To view all the journals, Sign up to Trinka AI.</p>
              <div class="row justify-content-center">
                <div class="col-lg-8">
                  <div class="btn-group">
                    <a
                      href="https://cloud.trinka.ai/signup?_rg=GB"
                      target="_blank" rel="noopener noreferrer"
                      class="filled-btn w-100"
                      >Sign up for Free</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="articleSection" *ngIf="seeArticle">
    <div class="journalFinderNavBar">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <ul>
              <li
                (click)="
                  seeArticle =
                    false &&
                    (seePublishArticleData = {
                      article_data: []
                    })
                "
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.1257 9.89635C18.1257 10.145 18.027 10.3835 17.8512 10.5593C17.6753 10.7351 17.4369 10.8339 17.1882 10.8339H5.70386L9.72886 14.8581C9.90498 15.0342 10.0039 15.2731 10.0039 15.5221C10.0039 15.7712 9.90498 16.0101 9.72886 16.1862C9.55274 16.3623 9.31387 16.4613 9.0648 16.4613C8.81573 16.4613 8.57686 16.3623 8.40074 16.1862L2.77574 10.5612C2.68834 10.4741 2.61899 10.3706 2.57167 10.2567C2.52436 10.1427 2.5 10.0205 2.5 9.89713C2.5 9.77375 2.52436 9.65157 2.57167 9.53762C2.61899 9.42366 2.68834 9.32017 2.77574 9.23307L8.40074 3.60807C8.48794 3.52087 8.59147 3.45169 8.70541 3.40449C8.81935 3.3573 8.94147 3.33301 9.0648 3.33301C9.18813 3.33301 9.31025 3.3573 9.42419 3.40449C9.53813 3.45169 9.64166 3.52087 9.72886 3.60807C9.81607 3.69528 9.88525 3.79881 9.93244 3.91275C9.97964 4.02669 10.0039 4.14881 10.0039 4.27213C10.0039 4.39546 9.97964 4.51758 9.93244 4.63152C9.88525 4.74546 9.81607 4.84899 9.72886 4.9362L5.70386 8.95885H17.1882C17.4369 8.95885 17.6753 9.05762 17.8512 9.23344C18.027 9.40926 18.1257 9.64771 18.1257 9.89635Z"
                    fill="#414E62"
                  />
                </svg>
              </li>
              <li>Journal Finder</li>
              <li>
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#viewAbstract_JF"
                >
                  View Abstract
                </button>
              </li>
              <li>Similar article publish in</li>
              <li>
                <select
                  name="journalList"
                  id="journalList"
                  [(ngModel)]="journalSelection"
                  (change)="onjournalSelectionOptionChange($event)"
                >
                  <ng-container
                    *ngFor="
                      let journal of journalFinalResult.journal_data
                        | citeScoreFilter
                          : citeScore_custom.min
                          : citeScore_custom.max
                        | openAccessFilter : filterDisplayList
                        | predatoryFilter : filterDisplayList
                        | impactFactorFilter
                          : impact_factor_custom.min
                          : impact_factor_custom.max
                        | HIndexFilter : hIndex_custom.min : hIndex_custom.max;
                      let k = index
                    "
                  >
                    <option [value]="journal.journal_title" *ngIf="k<3">
                      <b>#{{ journal.journal_rank }}</b>
                      {{ journal.journal_title }}
                      <span>({{ journal.similar_article_count }})</span>
                    </option>
                  </ng-container>
                </select>
              </li>
            </ul>
            
            <!-- <div class="articlePagination paginationShimmerLoader" *ngIf="seePublishArticleProgressShimmer">
              <p class="shimmerBG"></p>
            </div> -->
            <!-- <div class="articlePagination" *ngIf="
              seePublishArticleData.article_data.length != 0">
              <button
                type="button"
                class="btn-prev"
                (click)="onPageChange(page - 1)"
                [class.disabled]="page === 1"
              >
                <img src="../../../assets/images/paginationArrow.png" />
                <span
                  >{{ page }}&nbsp; - &nbsp;{{
                    mathCeil(
                      seePublishArticleData.article_data.length,
                      pageSize
                    ) || 0
                  }}</span
                >
              </button>
              <button
                type="button"
                class="btn-next"
                (click)="onPageChange(page + 1)"
                [class.disabled]="page === mathCeil(seePublishArticleData.article_data.length, pageSize)"
              >
                <img src="../../../assets/images/paginationArrow.png" />
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  
    <div class="container">
      <div
        class="row JF_shimmerLoaderSection"
        *ngIf="seePublishArticleProgressShimmer"
      >
        <div class="col-md-12" *ngFor="let item of shimmerLoaderRepeat">
          <div class="journalFinderResultCard">
            <div class="ResultCardBody">
              <div class="resultsBodyContents">
                <div class="JF_title shimmerBG"></div>
                <div class="JF_otherOption">
                  <ul>
                    <li class="shimmerBG"></li>
                    <li class="shimmerBG"></li>
                    <li class="shimmerBG"></li>
                  </ul>
                </div>
              </div>
              <div class="resultsSimilartiyScore shimmerBG"></div>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div class="row" *ngFor="let article of paginatedItems | slice:0:3; let j = index">
        <div class="col-md-12">
          <div class="journalFinderResultCard">
            <div class="ResultCardBody">
              <div class="resultsBodyContents">
                <div class="JF_title">
                  <svg
                    width="20"
                    height="24"
                    viewBox="0 0 20 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.0697 3.96793L4.73644 3.96536C4.40499 3.96547 4.08715 4.09722 3.85282 4.33164C3.61849 4.56606 3.48686 4.88394 3.48687 5.2154L3.49066 18.6215C3.49075 18.7858 3.5232 18.9484 3.58616 19.1C3.64912 19.2517 3.74135 19.3895 3.85758 19.5055C3.97381 19.6215 4.11176 19.7135 4.26356 19.7762C4.41535 19.8389 4.57801 19.871 4.74224 19.8708L15.0754 19.8734C15.2398 19.8734 15.4024 19.841 15.5542 19.7781C15.706 19.7152 15.8439 19.623 15.96 19.5067C16.0761 19.3905 16.1681 19.2525 16.2309 19.1006C16.2936 18.9487 16.3257 18.786 16.3255 18.6217L16.3217 5.21556C16.3211 4.88409 16.1888 4.56644 15.954 4.33247C15.7192 4.09851 15.4011 3.96738 15.0697 3.96793ZM15.074 18.6234L4.74001 18.621L4.73622 5.21485L15.0694 5.21742L15.074 18.6234ZM5.98635 7.09032C5.98653 6.92462 6.0525 6.76578 6.16976 6.64871C6.28702 6.53164 6.44597 6.46592 6.61166 6.466L13.1963 6.46715C13.3527 6.46697 13.5036 6.52548 13.619 6.63112C13.7344 6.73676 13.806 6.88184 13.8196 7.0377C13.8332 7.19356 13.7879 7.34886 13.6926 7.47293C13.5973 7.59699 13.4589 7.6808 13.3048 7.70778C13.2686 7.7141 13.2321 7.71736 13.1954 7.71754L6.61067 7.71563C6.44498 7.71545 6.28613 7.64948 6.16906 7.53222C6.05199 7.41496 5.98627 7.25602 5.98635 7.09032ZM5.98773 9.59057C5.98771 9.50847 6.00388 9.42717 6.03529 9.35132C6.06671 9.27547 6.11276 9.20656 6.17081 9.14851C6.22887 9.09046 6.29779 9.04442 6.37365 9.01301C6.4495 8.98161 6.5308 8.96546 6.6129 8.96548L13.1976 8.96739C13.355 8.966 13.5071 9.02402 13.6235 9.12984C13.7399 9.23567 13.8122 9.38152 13.8258 9.53828C13.8394 9.69503 13.7934 9.85116 13.697 9.97548C13.6005 10.0998 13.4607 10.1832 13.3055 10.2089C13.2691 10.2154 13.2322 10.2185 13.1952 10.2181L6.61064 10.2169C6.44501 10.2164 6.28637 10.1501 6.16957 10.0326C6.05277 9.9152 5.98737 9.7562 5.98773 9.59057ZM5.98819 12.0902C5.98898 11.9248 6.05528 11.7665 6.17256 11.6499C6.28984 11.5333 6.44854 11.468 6.61391 11.4682L9.9042 11.4663C10.0606 11.4661 10.2114 11.5246 10.3267 11.6302C10.4421 11.7357 10.5138 11.8807 10.5275 12.0365C10.5412 12.1923 10.496 12.3475 10.4009 12.4716C10.3057 12.5957 10.1675 12.6797 10.0135 12.7068C9.97735 12.7132 9.94077 12.7164 9.90411 12.7166L6.61174 12.7156C6.44616 12.7152 6.28749 12.6492 6.17058 12.5319C6.05367 12.4146 5.98807 12.2558 5.98819 12.0902Z"
                      fill="#647087"
                    />
                  </svg>
                  <h3>{{ article?.title }}</h3>
                </div>
                <div class="JF_otherOption">
                  <ul>
                    <li>
                      <p>
                        <svg
                          width="18"
                          height="19"
                          viewBox="0 0 18 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.50781 16.2507C1.50771 15.2803 1.74295 14.3244 2.19337 13.4649C2.64379 12.6054 3.29595 11.868 4.09393 11.3159C4.8919 10.7638 5.81188 10.4134 6.77497 10.2949C7.73807 10.1764 8.71554 10.2932 9.62356 10.6354M16.0413 12.9702C16.3401 12.6714 16.5079 12.2662 16.5079 11.8437C16.5079 11.4211 16.3401 11.0159 16.0413 10.7172C15.7425 10.4184 15.3373 10.2506 14.9148 10.2506C14.4923 10.2506 14.0871 10.4184 13.7883 10.7172L10.7808 13.7262C10.6025 13.9044 10.472 14.1247 10.4013 14.3667L9.77356 16.5192C9.75474 16.5837 9.75361 16.6521 9.77029 16.7172C9.78698 16.7824 9.82086 16.8418 9.8684 16.8893C9.91593 16.9369 9.97537 16.9707 10.0405 16.9874C10.1056 17.0041 10.174 17.003 10.2386 16.9842L12.3911 16.3564C12.6331 16.2857 12.8533 16.1552 13.0316 15.9769L16.0413 12.9702Z"
                            stroke="#647087"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.50781 10.25C9.57888 10.25 11.2578 8.57107 11.2578 6.5C11.2578 4.42893 9.57888 2.75 7.50781 2.75C5.43674 2.75 3.75781 4.42893 3.75781 6.5C3.75781 8.57107 5.43674 10.25 7.50781 10.25Z"
                            stroke="#647087"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Author:
                      </p>
                      <span
                        >{{ article.authors[0] || "NA" }} et al. | Published in
                        {{ article.date | date : "yyyy" || "NA" }}
                        <span *ngIf="article.googlescholar_title_link">|</span
                        ><a
                          *ngIf="article.googlescholar_title_link"
                          href="{{ article.googlescholar_title_link }}"
                          target="_blank" rel="noopener noreferrer"
                        >
                          View Article</a
                        ></span
                      >
                    </li>
                    <li>
                      <p>
                        <svg
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_21_27023)">
                            <path
                              d="M14.2026 12.8341V1.375C14.2021 1.31875 14.1794 1.26498 14.1395 1.22538C14.0995 1.18579 14.0455 1.16357 13.9893 1.16357H5.25977"
                              stroke="#647087"
                              stroke-width="1.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M1.79102 14.2702V2.86072C1.79202 2.41059 1.97141 1.97921 2.28988 1.6611C2.60835 1.34298 3.03993 1.16408 3.49006 1.16357H5.53959"
                              stroke="#647087"
                              stroke-width="1.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14.0082 15.8381H3.82721C2.5453 15.8381 1.79102 15.1715 1.79102 14.3334C1.79102 13.4953 2.5853 12.8096 3.82721 12.8096H14.0082C14.0587 12.8096 14.1071 12.8296 14.1428 12.8654C14.1786 12.9011 14.1986 12.9495 14.1986 13V15.6667C14.1939 15.7139 14.1718 15.7575 14.1365 15.7892C14.1013 15.8209 14.0555 15.8384 14.0082 15.8381Z"
                              stroke="#647087"
                              stroke-width="1.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10.6689 5.38867L7.04798 9.01153L5.32227 7.23629"
                              stroke="#647087"
                              stroke-width="1.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_21_27023">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        Subject Areas:
                      </p>
                      <span>{{ article.subject_area.join(", ") || "NA" }}</span>
                    </li>
                    <li>
                      <p>
                        <svg
                          width="19"
                          height="23"
                          viewBox="0 0 19 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 11.5H2.83333M9.5 4V4.83333M16.1667 11.5H17M4.16667 6.16667L4.75 6.75M14.8333 6.16667L14.25 6.75M7.58333 15.6667H11.4167M7 14.8333C6.30039 14.3086 5.78361 13.5771 5.52286 12.7424C5.26211 11.9076 5.27061 11.012 5.54715 10.1824C5.8237 9.35275 6.35427 8.63116 7.06371 8.11982C7.77315 7.60849 8.62549 7.33333 9.5 7.33333C10.3745 7.33333 11.2269 7.60849 11.9363 8.11982C12.6457 8.63116 13.1763 9.35275 13.4528 10.1824C13.7294 11.012 13.7379 11.9076 13.4771 12.7424C13.2164 13.5771 12.6996 14.3086 12 14.8333C11.6746 15.1554 11.4297 15.5495 11.2849 15.9839C11.1401 16.4182 11.0996 16.8805 11.1667 17.3333C11.1667 17.7754 10.9911 18.1993 10.6785 18.5118C10.366 18.8244 9.94203 19 9.5 19C9.05797 19 8.63405 18.8244 8.32149 18.5118C8.00893 18.1993 7.83333 17.7754 7.83333 17.3333C7.90038 16.8805 7.85988 16.4182 7.71511 15.9839C7.57034 15.5495 7.32536 15.1554 7 14.8333Z"
                            stroke="#647087"
                            stroke-width="1.25"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Concepts:
                      </p>
                      <span>{{ article.keyphrases.join(", ") || "NA" }}</span>
                    </li>
                    <li *ngIf="article.viewAbstract">
                      <p>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.3272 6.3092L12.1908 2.17284C12.1359 2.11798 12.0707 2.07449 11.999 2.04483C11.9272 2.01517 11.8503 1.99994 11.7727 2H4.68182C4.36838 2 4.06778 2.12451 3.84615 2.34615C3.62451 2.56778 3.5 2.86838 3.5 3.18182V16.1818C3.5 16.4953 3.62451 16.7959 3.84615 17.0175C4.06778 17.2391 4.36838 17.3636 4.68182 17.3636H15.3182C15.6316 17.3636 15.9322 17.2391 16.1539 17.0175C16.3755 16.7959 16.5 16.4953 16.5 16.1818V6.72727C16.5001 6.64965 16.4848 6.57278 16.4552 6.50104C16.4255 6.42931 16.382 6.36412 16.3272 6.3092ZM12.3636 4.01722L14.4828 6.13636H12.3636V4.01722ZM15.3182 16.1818H4.68182V3.18182H11.1818V6.72727C11.1818 6.88399 11.2441 7.03429 11.3549 7.14511C11.4657 7.25593 11.616 7.31818 11.7727 7.31818H15.3182V16.1818ZM11.9544 12.5736C12.3032 12.0194 12.4355 11.3562 12.3262 10.7107C12.2168 10.0651 11.8735 9.48246 11.3617 9.07405C10.85 8.66564 10.2057 8.4601 9.55194 8.4967C8.89821 8.5333 8.28088 8.80947 7.8179 9.27245C7.35493 9.73543 7.07875 10.3528 7.04216 11.0065C7.00556 11.6602 7.2111 12.3045 7.61951 12.8163C8.02792 13.328 8.61056 13.6714 9.25612 13.7807C9.90167 13.8901 10.5649 13.7577 11.119 13.409L11.9456 14.2362C12.0005 14.2912 12.0656 14.3347 12.1374 14.3644C12.2091 14.3941 12.286 14.4094 12.3636 14.4094C12.4413 14.4094 12.5182 14.3941 12.5899 14.3644C12.6616 14.3347 12.7268 14.2912 12.7817 14.2362C12.8366 14.1813 12.8802 14.1162 12.9099 14.0444C12.9396 13.9727 12.9549 13.8958 12.9549 13.8182C12.9549 13.7405 12.9396 13.6637 12.9099 13.5919C12.8802 13.5202 12.8366 13.455 12.7817 13.4001L11.9544 12.5736ZM8.22727 11.1591C8.22727 10.8669 8.31391 10.5813 8.47624 10.3384C8.63856 10.0954 8.86928 9.90608 9.13922 9.79427C9.40915 9.68246 9.70618 9.6532 9.99275 9.7102C10.2793 9.7672 10.5425 9.9079 10.7491 10.1145C10.9557 10.3211 11.0964 10.5843 11.1534 10.8709C11.2104 11.1575 11.1812 11.4545 11.0694 11.7244C10.9576 11.9944 10.7682 12.2251 10.5253 12.3874C10.2823 12.5497 9.99672 12.6364 9.70455 12.6364C9.31275 12.6364 8.937 12.4807 8.65996 12.2037C8.38291 11.9266 8.22727 11.5509 8.22727 11.1591Z"
                            fill="#727A93"
                          />
                        </svg>
                        Abstract:
                      </p>
                      <span>{{ article.abstract || "NA" }}</span>
                    </li>
                  </ul>
                </div>
                <div class="viewMoreAbstract_JF">
                  <p (click)="openAbstract(article, j)">
                    {{
                      article.viewAbstract ? "View  Less" : "View Abstract"
                    }}
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.19526 7.19526C4.45561 6.93491 4.87772 6.93491 5.13807 7.19526L8.66667 10.7239L12.1953 7.19526C12.4556 6.93491 12.8777 6.93491 13.1381 7.19526C13.3984 7.45561 13.3984 7.87772 13.1381 8.13807L9.13807 12.1381C8.87772 12.3984 8.45561 12.3984 8.19526 12.1381L4.19526 8.13807C3.93491 7.87772 3.93491 7.45561 4.19526 7.19526Z"
                        fill="#1A64E2"
                      />
                    </svg>
                  </p>
                </div>
              </div>
  
              <div class="resultsSimilartiyScore">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.5005 23.6814C20.2882 23.6814 20.9267 23.0428 20.9267 22.2551C20.9267 21.4674 20.2882 20.8289 19.5005 20.8289C18.7128 20.8289 18.0742 21.4674 18.0742 22.2551C18.0742 23.0428 18.7128 23.6814 19.5005 23.6814Z" fill="#DC2626"/>
                  <path d="M22.9875 17.58C19.9125 17.58 16.0125 17.58 16.0125 17.58C15.9525 17.58 15.9 17.58 15.84 17.58V16.71C15.84 14.5125 16.4625 13.05 19.5 13.05C22.7475 13.05 23.16 14.6325 23.16 16.0125C23.16 16.305 23.3325 26.9847 23.625 26.9847C23.9175 26.9847 24.21 16.305 24.21 16.0125C24.21 13.35 22.6275 12 19.5 12C15.2775 12 14.79 14.685 14.79 16.71V17.6475C12.69 17.91 12 18.975 12 21.5925V22.9875C12 26.0625 12.9375 27 16.0125 27H22.9875C26.0625 27 27 26.0625 27 22.9875V21.5925C27 18.5175 26.0625 17.58 22.9875 17.58ZM19.5 24.555C18.2475 24.555 17.235 23.535 17.235 22.29C17.235 21.0375 18.255 20.025 19.5 20.025C20.745 20.025 21.765 21.045 21.765 22.29C21.765 23.5425 20.7525 24.555 19.5 24.555Z" fill="#DC2626"/>
                  <path d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20ZM3 20C3 29.3888 10.6112 37 20 37C29.3888 37 37 29.3888 37 20C37 10.6112 29.3888 3 20 3C10.6112 3 3 10.6112 3 20Z" fill="#EFF1F5"/>
                  <path d="M20 1.5C20 0.671573 20.6725 -0.00585192 21.4986 0.0562205C24.5783 0.287625 27.5699 1.22984 30.2349 2.81723C33.3304 4.66109 35.8704 7.30697 37.5863 10.4752C39.3023 13.6435 40.1304 17.2165 39.9833 20.8166C39.8362 24.4167 38.7193 27.9102 36.7506 30.9279C34.7818 33.9456 32.0345 36.3754 28.7988 37.9606C25.5631 39.5457 21.9593 40.2273 18.3682 39.9333C14.7771 39.6393 11.3321 38.3807 8.39731 36.2904C5.87072 34.4909 3.80306 32.1325 2.35044 29.4071C1.96079 28.676 2.30983 27.7875 3.06804 27.4538V27.4538C3.82625 27.12 4.70572 27.468 5.10501 28.1939C6.33337 30.4268 8.05149 32.361 10.1377 33.8469C12.6323 35.6236 15.5605 36.6934 18.613 36.9433C21.6654 37.1932 24.7286 36.6138 27.479 35.2665C30.2293 33.9191 32.5646 31.8538 34.238 29.2887C35.9114 26.7237 36.8608 23.7542 36.9858 20.6941C37.1109 17.634 36.4069 14.597 34.9484 11.904C33.4898 9.21092 31.3309 6.96193 28.6996 5.39464C26.4991 4.08392 24.0367 3.2907 21.4981 3.06613C20.6729 2.99313 20 2.32843 20 1.5V1.5Z" fill="#DC2626"/>
                </svg>
                <div class="similarityScoreTooltip">
                  <p>To view similarity score, <a href="https://cloud.trinka.ai/signup?_rg=GB" class="text-white" style="text-decoration: underline;">Sign up</a> to Trinka AI. </p>
                </div>
                <h5>Similarity Score</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="row" *ngIf="isAllSimilarArticles">
        <div class="col-md-12">
          <div class="journal-blur" style="margin-top: 0;">
            <img
              src="../../../assets/images/listOfStackJournalFinder.png"
              loading="lazy"
              decoding="async"
              alt="journals"
              class="img-fluid"
            />
            <div class="locked-result">
              <h5>Locked Result</h5>
              <p>To view all the similar articles published related to your paper, please sign up to Trinka AI for free.</p>
              <div class="row justify-content-center">
                <div class="col-lg-8">
                  <div class="btn-group">
                    <a
                      href="https://cloud.trinka.ai/signup?_rg=GB"
                      target="_blank" rel="noopener noreferrer"
                      class="filled-btn w-100"
                      >Sign up for Free</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          !seePublishArticleProgressShimmer &&
          seePublishArticleData.article_data.length == 0
        "
      >
        <div class="col-md-12">
          <div class="journalFinderResultCard">
            <div class="noArticleFounds">
              <h3>No Article Found.</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <div class="applySettingPopup" *ngIf="applySettingPopup">
    <div class="applySettingContents">
      <svg class="spinner">
        <circle style="cx: 50%; cy: 50%; r: 50%">
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="-90;810"
            keyTimes="0;1"
            dur="2s"
            repeatCount="indefinite"
          ></animateTransform>
          <animate
            attributeName="stroke-dashoffset"
            values="0%;0%;-157.080%"
            calcMode="spline"
            keySplines="0.61, 1, 0.88, 1; 0.12, 0, 0.39, 0"
            keyTimes="0;0.5;1"
            dur="2s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="stroke-dasharray"
            values="0% 314.159%;157.080% 157.080%;0% 314.159%"
            calcMode="spline"
            keySplines="0.61, 1, 0.88, 1; 0.12, 0, 0.39, 0"
            keyTimes="0;0.5;1"
            dur="2s"
            repeatCount="indefinite"
          ></animate>
        </circle>
      </svg>
      <span>Apply Setting</span>
    </div>
  </div>
  
  <!-- Show abstract modal -->
  <div
    class="modal fade"
    id="viewAbstract_JF"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.4082 6.66472C17.7614 6.31148 17.7614 5.73877 17.4082 5.38553C17.0549 5.0323 16.4822 5.0323 16.129 5.38553L11.3414 10.1731L6.55388 5.38553C6.20064 5.0323 5.62793 5.0323 5.27469 5.38553C4.92146 5.73877 4.92146 6.31148 5.27469 6.66472L10.0622 11.4523L5.27469 16.2398C4.92146 16.593 4.92146 17.1658 5.27469 17.519C5.62793 17.8722 6.20064 17.8722 6.55388 17.519L11.3414 12.7315L16.129 17.519C16.4822 17.8722 17.0549 17.8722 17.4082 17.519C17.7614 17.1658 17.7614 16.593 17.4082 16.2398L12.6206 11.4523L17.4082 6.66472Z"
                fill="#414E62"
              />
            </svg>
          </button>
          <h2>Abstract</h2>
          <p>{{ searchText }}</p>
        </div>
      </div>
    </div>
  </div>
  